import React from "react";
import { Badge } from '../../components/Badge';

type ProfileComponentProps = {
	name: string;
	imageSrc?: string;
	location?: string;
	completed?: boolean;
};
export default function ProfileComponent({
	name,
	imageSrc,
	location,
	completed,
}: ProfileComponentProps) {
	const variant = completed ? "default" : "success";
	return (
		<div className="flex items-center text-sm  w-full ">
			{imageSrc ? (
				<div className="relative w-[5rem] h-[4rem] mr-3 rounded-full md:block">
					<img
						className="object-cover w-full h-full rounded-lg"
						src={imageSrc}
						alt=""
						loading="lazy"
					/>
					<div
						className="absolute inset-0 rounded-full shadow-inner"
						aria-hidden="true"
					></div>
				</div>
			) : null}
			<div className="gap-1 flex flex-col w-full">
				<span className="font-semibold text-gray-900 dark:text-gray-100">{name}</span>
				<div className="flex flex-row gap-2 w-full">
					{" "}
					<span className="text-xs text-gray-600 dark:text-gray-400">{location}</span>
					<Badge
						label={completed ? "Completed" : "Active"}
						variant={variant}
						size="sm"
					/>
				</div>
			</div>
		</div>
	);
}
